<div class="entity-actions">
  <ng-content select="[prepend]"></ng-content>
  <button
    *ngIf="config?.showExport"
    mat-raised-button
    type="button"
    matBadgePosition="before"
    matBadgeColor="accent"
    [matBadge]="selectedItemsCount !== 0 ? selectedItemsCount : undefined"
    (click)="exportHandler()">
    <span *ngIf="selectedItemsCount === 0">{{ 'Esporta tutto' | translate }}</span>
    <span *ngIf="selectedItemsCount !== 0">{{ 'Esporta selezionati' | translate }}</span>
  </button>

  <button
    mat-raised-button
    matBadgePosition="before"
    matBadgeColor="accent"
    type="button"
    *ngIf="config?.showAddToCollection"
    [matBadge]="selectedItemsCount"
    [disabled]="selectedItemsCount === 0"
    (click)="addToCollectionHandler()">
    {{ config?.addToCollectionLabel | translate }}
  </button>

  <ng-container *roleVisibility="['create']; classNames: [className]">
    <button
      mat-raised-button
      matBadgePosition="before"
      matBadgeColor="accent"
      type="button"
      *ngIf="config?.showDelete"
      [matBadge]="selectedItemsCount"
      [disabled]="selectedItemsCount === 0"
      (click)="deleteHandler()">
      {{ config?.deleteLabel | translate }}
    </button>
  </ng-container>
  <ng-container *roleVisibility="['delete']; classNames: [className]">
    <button
      mat-raised-button
      color="primary"
      type="button"
      *ngIf="config?.showAdd"
      (click)="add.emit()">
      {{ config?.addLabel | translate }}
    </button>
  </ng-container>
  <ng-content select="[append]"></ng-content>
</div>
